// Central role registry — display labels + hierarchy. Internal keys stay stable;
// only the labels shown to people changed to Mavula's naming.
export const ROLES = {
  ceo: { label: "Founder / Super Guardian", level: 5, tagline: "Full system control, vision & policy" },
  manager: { label: "Regional Steward", level: 4, tagline: "Oversees a country/region & onboards agents" },
  super_admin: { label: "Team Lead", level: 3, tagline: "Guides agents, reviews & approves work" },
  agent: { label: "Verified Field Agent", level: 2, tagline: "Registers users & submits listings" },
  auditor: { label: "Compliance Auditor", level: 2, tagline: "Read-only oversight of logs & records" },
  support: { label: "Support Assistant", level: 1, tagline: "Helps users & agents, escalates issues" },
  member: { label: "Member", level: 0, tagline: "Public community member" },
};

export const ROLE_LEVELS = Object.fromEntries(
  Object.entries(ROLES).map(([k, v]) => [k, v.level])
);

export const roleLabel = (r) => ROLES[r]?.label || (r || "").replace(/_/g, " ");
export const roleTagline = (r) => ROLES[r]?.tagline || "";

// Roles that can be created/assigned (everything except plain member appears in pickers).
export const ASSIGNABLE_ORDER = ["support", "auditor", "agent", "super_admin", "manager", "ceo"];
